import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';

import * as Sentry from "@sentry/angular";
import {environment} from "./environments/environment";

Sentry.init({
    dsn: "https://e6546111e6772be31c65fefa5536002b@log.nebulalabs.cc/25",
    environment: environment.environmentName,
    beforeSend(event, hint) {
        const error = hint?.originalException;
        if (typeof error?.toString === 'function' &&
            error.toString().includes('ExpressionChangedAfterItHasBeenCheckedError')) {
            // I don't think colours changing after init is worth an error
            return null;
        }

        return event;
    },
});

platformBrowserDynamic().bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
}).catch(err => console.error(err));
